import $ from 'jquery';
import Preloader from '../../src/modules/Preloader';

class BackgroundVideo{

    constructor(src, container){
		this.src = src;
		this.container = container;
		this.video;
		

		this.show();

    }

    show(){

 		this.video = document.createElement('video');
		this.video.className = "background-video-player";
		this.video.muted = true;
		this.video.loop = true;
		this.video.playsInline = true;
		this.video.src = this.src;
		this.container.appendChild(this.video);

		this.preloader = new Preloader(this.container);

		this.preloader.show();

		$(this.container).fadeIn("slow");

		this.video.addEventListener("canplaythrough", ( event )=> {

			event.target.play();

			this.preloader.hide();

		});
		       
        
    }


}

export default BackgroundVideo;